import { TranslationRepository } from '../data/translation-repository';
import { TranslationKey, UpdateTranslationRequest } from '../types/translation-types';

export class UpdateTranslationUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(id: number, data: UpdateTranslationRequest): Promise<TranslationKey> {
    return this.repository.update(id, data);
  }
}
